<dl class="description-list">
  @for (entry of entries; track entry) {
    <dt
      [attr.data-test-id]="entry.id ? entry.id + 'Label' : null"
      class="be-component-text--sm description-list__label"
      >
      {{ entry?.label }}
    </dt>
    <dd
      [attr.data-test-id]="entry.id ? entry.id + 'Value' : null"
      class="be-component-text--sm description-list__value"
      >
      {{ entry?.value }}
    </dd>
  }
</dl>
